import { createContext } from "react";
var IconContext = /*#__PURE__*/ createContext({});
export default IconContext;
